import React, { forwardRef, type MutableRefObject } from 'react';
import { useIsOrgAdmin } from '@jira/platform-services-is-org-admin/src/is-org-admin.tsx';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { shouldShowTrashProjectTrigger } from '@atlassian/jira-project-restore-utils/src/utils/show-trash-trigger/index.tsx';
import messages from './messages.tsx';

type Props = {
	projectType: ProjectType;
	isAdmin: boolean;
	canAdministerProject: boolean;
	isSimplified: boolean;
	onClick: () => void;
};

export const TrashProjectDropdownItem = forwardRef(
	(
		{ onClick, ...args }: Props,
		ref: MutableRefObject<HTMLElement | null> | ((instance: HTMLElement | null) => void) | null,
	) => {
		const { formatMessage } = useIntl();
		const { loading: isLoadingAdminStatus, isOrgAdmin } = fg('block-delete-jira')
			? // eslint-disable-next-line react-hooks/react-compiler
				// eslint-disable-next-line react-hooks/rules-of-hooks
				useIsOrgAdmin()
			: { loading: null, isOrgAdmin: null };
		if (!shouldShowTrashProjectTrigger({ ...args, isLoadingAdminStatus, isOrgAdmin })) {
			return null;
		}

		return (
			<DropdownItem ref={ref} onClick={onClick}>
				{formatMessage(messages.delete)}
			</DropdownItem>
		);
	},
);
